import moment from 'moment';
import Swal from 'sweetalert2';
import { getAccounting } from '../../../../../../../redux/fetchActions/legadoPage/accountingApp';
import { getAccountingV2 } from '../../../../../../../redux/fetchActions/legadoPage/accountingV2App';
import getClosedDataV2 from '../../../../../../../redux/fetchActions/legadoPage/closedReportApp';

function checkDate(dateSearch: string, dispatch: any) {
  const atualDate = moment();
  const searchDate = moment(dateSearch);

  if (searchDate > atualDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data de pesquisa não pode ser maior que a data atual!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (dateSearch === '') {
    return Swal.fire({
      icon: 'warning',
      title: 'Selecione uma data!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  return dispatch(getAccounting(dateSearch));
}

export function reportUnifield(
  initDateSearch: string,
  endDateSearch: string,
  fare: string,
  dispatch: any
) {
  const atualDate = moment();
  const initalSearchDate = moment(initDateSearch);
  const endSearchDate = moment(endDateSearch);

  if (initalSearchDate > atualDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data de pesquisa não pode ser maior que a data atual!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (initalSearchDate > endSearchDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data final não pode ser menor que a data inicial!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (endSearchDate > atualDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data de pesquisa não pode ser maior que a data atual!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (initDateSearch === '') {
    return Swal.fire({
      icon: 'warning',
      title: 'Selecione uma data!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (endDateSearch === '') {
    return Swal.fire({
      icon: 'warning',
      title: 'Selecione uma data!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  return dispatch(getAccountingV2(initDateSearch, endDateSearch, fare));
}

export function reportClosed(
  initDateSearch: string,
  endDateSearch: string,
  fare: string,
  dispatch: any
) {
  const atualDate = moment();
  const initalSearchDate = moment(initDateSearch);
  const endSearchDate = moment(endDateSearch);

  if (initalSearchDate > atualDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data de pesquisa não pode ser maior que a data atual!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (initalSearchDate > endSearchDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data final não pode ser menor que a data inicial!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (endSearchDate > atualDate) {
    return Swal.fire({
      icon: 'warning',
      title: 'A data de pesquisa não pode ser maior que a data atual!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (initDateSearch === '') {
    return Swal.fire({
      icon: 'warning',
      title: 'Selecione uma data!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  if (endDateSearch === '') {
    return Swal.fire({
      icon: 'warning',
      title: 'Selecione uma data!',
      confirmButtonText: 'Tentar novamente',
    });
  }

  return dispatch(getClosedDataV2(initDateSearch, endDateSearch, fare));
}

export default checkDate;
